import React from 'react';
import { Link } from 'react-router-dom';
import API from '../../servicios/api';

import mediosTransporte from '../../data/mediostransporte.json';

class Perfil4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            datosCargados:false,
            empleado: [],
            errores: [],
            serverror: ""
         };
    }

    componentDidMount(){
        const keyAPI = this.props.match.params.claveapi; // Se cambio para evitar usuarios curiosos
        fetch(API +"?consultarKeyAPI", {
            method:"POST",
            body: JSON.stringify({claveAPI:keyAPI})
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.length>0 && datos[0].claveAPI){
                // Format some values
                let empleado = datos[0];
                // empleado.creditosfundacion = (empleado.creditosfundacion === "1") ? "Si" : "No";
                // empleado.creditosbancos = (empleado.creditosbancos === "1") ? "Si" : "No";
                // empleado.creditosprestamistas = (empleado.creditosprestamistas === "1") ? "Si" : "No";
                empleado.haymenores = (empleado.haymenores === "1") ? "Si" : "No";
                empleado.estudianmenores = (empleado.estudianmenores === "1") ? "Si" : "No";
                empleado.recibeauxilio = (empleado.recibeauxilio === "1") ? "Si" : "No";
                empleado.quierencapacitarse = (empleado.quierencapacitarse === "1") ? "Si" : "No";
                if (empleado.transportebeneficiario === "")  empleado.transportebeneficiario = "Seleccionar...";

                this.setState({ 
                    datosCargados:true,
                    empleado: empleado
                });
            } else {
                this.setState({ 
                    datosCargados:true,
                    empleado: []
                });
            }
        })
        .catch(console.log)
    }

    cambioValor = (e) =>{
        const state = this.state.empleado;
        state[e.target.name] = e.target.value;
        this.setState( { empleado:state, errores:[], serverror:""});
    }

    verificarError(elm){
        return this.state.errores.indexOf(elm) !== -1;
    }

    enviarDatos = (e) => {
        e.preventDefault();
        let { id, docId, claveAPI,
            creditosfundacion, creditosbancos, creditosprestamistas,
            transportebeneficiario, haymenores, estudianmenores, cuantosmenores,
            cuantosmayores, matricula, mensualidad, pagoutilesescolares, gastotransporte,
            recibeauxilio, quierencapacitarse, enquecapacitacion
        } = this.state.empleado;

        // Validar Errores
        let errores = [];
        if (!docId) errores.push('error_docId');
        if (!creditosfundacion) errores.push('error_creditosfundacion');
        if (!creditosbancos) errores.push('error_creditosbancos');
        if (!creditosprestamistas) errores.push('error_creditosprestamistas');
        // if (!transportebeneficiario) errores.push('error_transportebeneficiario');
        if (!haymenores) errores.push('error_haymenores');
        if (!estudianmenores) errores.push('error_estudianmenores');
        if (!cuantosmenores) errores.push('error_cuantosmenores');
        if (!cuantosmayores) errores.push('error_cuantosmayores');
        if (!matricula) errores.push('error_matricula');
        if (!mensualidad) errores.push('error_mensualidad');
        if (!pagoutilesescolares) errores.push('error_pagoutilesescolares');
        if (!gastotransporte) errores.push('error_gastotransporte');
        if (!recibeauxilio) errores.push('error_recibeauxilio');
        if (!quierencapacitarse) errores.push('error_quierencapacitarse');
        // if (!enquecapacitacion) errores.push('error_enquecapacitacion');
        
        if(transportebeneficiario==="Seleccionar...") errores.push('error_transportebeneficiario');
        
        this.setState({errores:errores});
        if (errores.length>0) {
            console.log(errores);
            return false;
        }
        creditosbancos = (creditosbancos.toLocaleLowerCase()==="si") ? "1": "0";
        creditosfundacion = (creditosfundacion.toLocaleLowerCase()==="si") ? "1": "0";
        creditosprestamistas = (creditosprestamistas.toLocaleLowerCase()==="si") ? "1": "0";
        haymenores = (haymenores.toLocaleLowerCase()==="si") ? "1": "0";
        estudianmenores = (estudianmenores.toLocaleLowerCase()==="si") ? "1": "0";
        recibeauxilio = (recibeauxilio.toLocaleLowerCase()==="si") ? "1": "0";
        quierencapacitarse = (quierencapacitarse.toLocaleLowerCase()==="si") ? "1": "0";
        // creditosfundacion = (creditosfundacion.toLocaleLowerCase()==="si" || creditosfundacion.toLocaleLowerCase()==="1") ? 1 : 0;
        // creditosprestamistas = (creditosprestamistas.toLocaleLowerCase()==="si" || creditosprestamistas.toLocaleLowerCase()==="1") ? 1 : 0;
        // haymenores = (haymenores.toLocaleLowerCase()==="si" || haymenores.toLocaleLowerCase()==="1") ? 1 : 0;
        // estudianmenores = (estudianmenores.toLocaleLowerCase()==="si" || estudianmenores.toLocaleLowerCase()==="1") ? 1 : 0;
        // recibeauxilio = (recibeauxilio.toLocaleLowerCase()==="si" || recibeauxilio.toLocaleLowerCase()==="1") ? 1 : 0;

        var datosaEnviar = { id:id, claveAPI:claveAPI, docId:docId, 
            creditosbancos:creditosbancos, creditosprestamistas:creditosprestamistas, creditosfundacion:creditosfundacion,
            transportebeneficiario:transportebeneficiario, haymenores:haymenores, estudianmenores:estudianmenores, cuantosmenores:cuantosmenores,
            cuantosmayores:cuantosmayores, matricula:matricula, mensualidad:mensualidad, pagoutilesescolares:pagoutilesescolares, gastotransporte:gastotransporte,
            recibeauxilio:recibeauxilio, quierencapacitarse:quierencapacitarse, enquecapacitacion:enquecapacitacion
        };
        // console.log(datosaEnviar);
        fetch(API +"?actualizarperfil4=1", {
            method:"POST",
            body: JSON.stringify(datosaEnviar)
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.error && datos.error!==""){
                this.setState({serverror:datos.error});
            } else {
                this.props.history.push("/familiares/"+datos.claveAPI+"_"+datos.docId);
            }
        })
        .catch(console.log)
    }

    render() { 

        const { 
            datosCargados, empleado, serverror
        } = this.state;
        const { 
            docId, claveAPI,
            creditosbancos, creditosprestamistas, creditosfundacion,
            transportebeneficiario, haymenores, estudianmenores, cuantosmenores,
            cuantosmayores, matricula, mensualidad, pagoutilesescolares, gastotransporte,
            recibeauxilio, quierencapacitarse, enquecapacitacion
        } = empleado;

        if (!datosCargados) {
            return(<div><div className="spinner-border text-success"></div>Cargando datos...</div>);
        } else {
            if (datosCargados && empleado.length===0){
                return (<div>No hay registros</div>);
            } else {
        return ( 
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>PERFIL EMPLEADO</strong></div>
                        <div>4 de 5</div>
                    </div>
                </div>
                <div className="card-body">
                    <form onSubmit={this.enviarDatos}>
                        <div className="form-group oculto">
                            <label htmlFor=""><strong>Número Documento</strong></label>
                            <input readOnly type="text" name="docId" value={docId} onChange={this.cambioValor} id="docId"
                                className={((this.verificarError("error_docId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                        </div>

                        <div className="form-group">
                            <label htmlFor=""><strong>Hay menores de edad en la familia?</strong></label>
                            <div className={((this.verificarError("error_haymenores")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {haymenores}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="haymenores" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="haymenores" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        <div className="form-group oculto">
                            <label htmlFor=""><strong>Los menores de edad asisten actualemente al colegio?</strong></label>
                            <div className={((this.verificarError("error_estudianmenores")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {estudianmenores}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="estudianmenores" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="estudianmenores" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        
                        <label htmlFor=""><strong>Cuántos personas en la familia estudian?</strong></label>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                            <label htmlFor="">Menores de edad</label>
                            <input type="number" id="cuantosmenores" name="cuantosmenores" value={cuantosmenores} onChange={this.cambioValor}
                                className={((this.verificarError("error_cuantosmenores")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                            <div className="form-group">
                                <label htmlFor="">Mayores de edad</label>
                                <input type="number" id="cuantosmayores" name="cuantosmayores" value={cuantosmayores} onChange={this.cambioValor}
                                    className={((this.verificarError("error_cuantosmayores")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <label htmlFor=""><strong>Cuánto gasta por concepto de educación en la familia?</strong></label>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor="">Matrículas</label>
                                <input type="number" id="matricula" name="matricula" value={matricula} onChange={this.cambioValor}
                                    className={((this.verificarError("error_matricula")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Mensualidades</label>
                                <input type="number" id="mensualidad" name="mensualidad" value={mensualidad} onChange={this.cambioValor}
                                    className={((this.verificarError("error_mensualidad")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor="">Útiles escolares</label>
                                <input type="number" id="pagoutilesescolares" name="pagoutilesescolares" value={pagoutilesescolares} onChange={this.cambioValor}
                                    className={((this.verificarError("error_pagoutilesescolares")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Transporte</label>
                                <input type="number" id="gastotransporte" name="gastotransporte" value={gastotransporte} onChange={this.cambioValor}
                                    className={((this.verificarError("error_gastotransporte")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor=""><strong>Recibe auxilio económico?</strong></label>
                            <div className={((this.verificarError("error_recibeauxilio")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {recibeauxilio}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="recibeauxilio" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="recibeauxilio" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        <label htmlFor=""><strong>Tiene créditos con?</strong></label>
                        <div className="form-group-inline">
                            <label htmlFor="">Fundación</label>
                            <div className={((this.verificarError("error_creditosfundacion")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="creditosfundacion" value="1" defaultChecked={(creditosfundacion === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="creditosfundacion" value="0" defaultChecked={(creditosfundacion === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor="">Entidades financieras</label>
                            <div className={((this.verificarError("error_creditosbancos")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="creditosbancos" value="1" defaultChecked={(creditosbancos === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="creditosbancos" value="0" defaultChecked={(creditosbancos === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor="">Prestamistas</label>
                            <div className={((this.verificarError("error_creditosprestamistas")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="creditosprestamistas" value="1" defaultChecked={(creditosprestamistas === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="creditosprestamistas" value="0" defaultChecked={(creditosprestamistas === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline"></div>
                        {/* <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor="">Fundación</label>
                                <div className={((this.verificarError("error_creditosfundacion")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {creditosfundacion}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="creditosfundacion" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="creditosfundacion" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                            <label htmlFor="">Entidades financieras</label>
                            <div className={((this.verificarError("error_creditosbancos")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {creditosbancos}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="creditosbancos" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="creditosbancos" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="">Prestamistas</label>
                            <div className={((this.verificarError("error_creditosprestamistas")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {creditosprestamistas}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="creditosprestamistas" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="creditosprestamistas" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div> */}

                        <div className="form-group">
                            <label htmlFor=""><strong>Qué medio de transporte utiliza para desplazarse?</strong></label>
                            <div className={((this.verificarError("error_transportebeneficiario")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {transportebeneficiario}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    {mediosTransporte.tipo.map(e => {
                                        return (
                                            <button onClick={this.cambioValor} key={e.id} name="transportebeneficiario" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                        )
                                    })}
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        <div className="form-group">
                            <label htmlFor=""><strong>Le gustaría a usted y su familia recibir capacitación?</strong></label>
                            <div className={((this.verificarError("error_quierencapacitarse")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                <button className="btn btn-info dropdown-size-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {quierencapacitarse}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button onClick={this.cambioValor} key={1} name="quierencapacitarse" value="Si" className="dropdown-item" type="button">Si</button>
                                    <button onClick={this.cambioValor} key={2} name="quierencapacitarse" value="No" className="dropdown-item" type="button">No</button>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group">
                            <label htmlFor=""><strong>En que le gustaría a usted y su familia recibir capacitación?</strong></label>
                            <input type="text" id="enquecapacitacion" name="enquecapacitacion" value={enquecapacitacion} onChange={this.cambioValor}
                                className={((this.verificarError("error_enquecapacitacion")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        <div className="server-error">{serverror}</div>

                        <hr width="90%" />
                        <div className="btn-group btn-acciones" aria-label="">
                            <div className='btn-size-sm'><Link to={"/perfil3/" + claveAPI} className="btn btn-warning btn-size-sm">Atras</Link></div>
                            <div><button type="submit" className="btn btn-success">Siguiente</button></div>
                        </div>
                        
                    </form>
                </div>
                {/* <div className="card-footer text-muted">
                    
                </div> */}
            </div>
        );
            }
        }
    }
}

export default Perfil4;